// extracted by mini-css-extract-plugin
export default {"footlink":"index_footlink_YYEdo","fk_l":"index_fk_l_KjpQs","noBorder":"index_noBorder_rWkJa","copyright":"index_copyright_CyJXb"};